module.exports = __webpack_public_path__ + "img/bg-1.c8616860.png";